import { render } from "./NotAuthorizedView.vue?vue&type=template&id=96cf5ad0"
import script from "./NotAuthorizedView.vue?vue&type=script&lang=js"
export * from "./NotAuthorizedView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__